import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Progress() {
  const [employees, setEmployees] = useState([]);
  const [modules, setModules] = useState([]);
  const [assignments, setAssignments] = useState([]);

  const load = async () => {
    const [e, m, a] = await Promise.all([api.get("/employees"), api.get("/training/modules"), api.get("/training/assignments")]);
    setEmployees(e.data); setModules(m.data); setAssignments(a.data);
  };
  useEffect(() => { load(); }, []);

  const empRows = useMemo(() => {
    return employees.map((e) => {
      const mine = assignments.filter((a) => a.employee_id === e.employee_id);
      const required = mine.filter((a) => (modules.find((m) => m.module_id === a.module_id) || {}).required);
      const passed = required.filter((a) => a.status === "passed").length;
      const stuck = mine.filter((a) => a.status === "in_progress" || a.status === "failed").length;
      return { ...e, total: required.length, passed, stuck, ready: !!e.ready_at };
    });
  }, [employees, modules, assignments]);

  const stuckByModule = useMemo(() => {
    const map = {};
    for (const a of assignments) {
      if (a.status !== "in_progress" && a.status !== "failed") continue;
      const m = modules.find((x) => x.module_id === a.module_id);
      if (!m) continue;
      map[m.module_id] = (map[m.module_id] || { title: m.title, count: 0 });
      map[m.module_id].count += 1;
    }
    return Object.values(map).sort((a, b) => b.count - a.count);
  }, [assignments, modules]);

  const signoff = async (eid) => {
    await api.post("/training/practical-signoff", { employee_id: eid, signed_off: true });
    toast.success("Practical signed off"); load();
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight mb-1">Training progress</h1>
      <p className="text-sm text-[#A1A1AA] mb-6">Readiness per employee + stuck modules.</p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
        <div className="tt-card p-5 lg:col-span-2">
          <div className="tt-label mb-3">Everyone</div>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[#71717A] text-xs font-mono"><th className="text-left pb-2">Name</th><th className="text-left pb-2">Role</th><th className="text-right pb-2">Passed/Req</th><th className="text-right pb-2">Stuck</th><th className="text-left pb-2 pl-4">Status</th><th></th></tr>
            </thead>
            <tbody>
              {empRows.map((e) => (
                <tr key={e.employee_id} className="border-t border-[#1E1E1E]">
                  <td className="py-2">{e.display_name || e.legal_name}</td>
                  <td className="py-2 text-[#A1A1AA]">{e.role_title}</td>
                  <td className="py-2 text-right font-mono">{e.passed}/{e.total}</td>
                  <td className="py-2 text-right font-mono">{e.stuck > 0 ? <span className="text-[#F5A524]">{e.stuck}</span> : "0"}</td>
                  <td className="py-2 pl-4">{e.ready ? <span className="tt-badge-pass">Ready</span> : <span className="tt-badge-neutral">In progress</span>}</td>
                  <td className="py-2 text-right">{!e.ready && <button onClick={() => signoff(e.employee_id)} className="tt-btn-ghost text-xs text-[#5B9BFF]">Sign off practical</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="tt-card p-5">
          <div className="tt-label mb-3">Stuck modules</div>
          {stuckByModule.length === 0 && <div className="text-sm text-[#71717A]">Nobody stuck.</div>}
          {stuckByModule.map((s) => (
            <div key={s.title} className="flex items-center justify-between py-1 border-b border-[#1E1E1E] last:border-0">
              <span className="text-sm">{s.title}</span>
              <span className="font-mono text-[#F5A524]">{s.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
